module.exports = __webpack_public_path__ + "img/combos.1a87a1c1.svg";